import http from './httpService';
import config from '../configs/config.js';
import { deviceDetect } from 'react-device-detect';
import { smallDate } from '../utils/constants';

const url = config.apiEndPoint + '/security';

// 1. Get logged in user entries
export async function getSecurityEntries() {
  try {
    const data = await http.get(url + '/me');
    return data;
  } catch (err) {
    console.log(err.response);
  }
}

// 2. Get all user entries
export async function getAllSecurityEntries() {
  try {
    const data = await http.get(url);
    data.data.forEach(function (data) {
      data.date = new Date(data.time).toLocaleString(undefined, smallDate);
    });
    return data;
  } catch (err) {
    console.log(err.response);
  }
}

//----------------------------------- Get Device Information ----------------------------------//
export async function getDeviceInfo() {
  const json = {};
  const deviceInfo = Object.keys(deviceDetect());
  const device = deviceDetect();
  if (deviceInfo.includes('isBrowser')) {
    json['device'] = device.browserName + ' ' + device.browserFullVersion;
    json['os'] = device.osName + ' ' + device.osVersion;
  } else if (
    deviceInfo.includes('isMobile') ||
    deviceInfo.includes('isTablet')
  ) {
    json['device'] = device.vendor + ' ' + device.model;
    json['os'] = device.os + ' ' + device.osVersion;
  } else {
    json['device'] = 'Unidentified';
    json['os'] = 'Unidentified';
  }
  return json;
}
